<template lang="pug">
.links.p-XS(v-if="dashboards.length > 0")
  a.link.p-XS(
      v-for="dashboard in globalDashboards"
      :class="activeDashboard === dashboard.DashboardId ? `active` : ``"
      :href="`/dashboard/${dashboard.DashboardId}`"
      ) {{ dashboard.Label }}
  BriqMenuDropdown.p-XS(
    v-if="nonGlobalDashboards.length > 0"
    label="More..."
    :items="nonGlobalDashboardsMenuItems"
    :onClick="goToLink"
    :activeItem="activeDashboard"
    )
</template>

<script>
import { map } from 'ramda'
import ClickOutside from 'vue-click-outside'
import BriqMenuDropdown from '@v/components/BriqMenuDropdown.vue'

export default {
  name: 'DashboardsMenu',
  props: {
    dashboards: Array,
  },
  components: {
    BriqMenuDropdown,
  },
  directives: {
    ClickOutside,
  },
  data: () => ({
    activeDashboard: '',
    isMenuOpen: false,
  }),
  computed: {
    globalDashboards() {
      return this.dashboards.filter(d => d.IsGlobal === true)
    },
    nonGlobalDashboards() {
      return this.dashboards.filter(d => d.IsGlobal === false)
    },
    nonGlobalDashboardsMenuItems() {
      return map(d => {
        return {
          id: d.DashboardId,
          label: d.Label,
        }
      })(this.nonGlobalDashboards)
    },
  },
  methods: {
    getActiveDashboard() {
      const url = window.location.href
      return url.substr(url.lastIndexOf('/') + 1)
    },
    goToLink(item) {
      this.$window.location.href = `/dashboard/${item.id}`
    },
  },
  mounted() {
    this.activeDashboard = this.getActiveDashboard()
  },
}
</script>

<style scoped lang="stylus">
.links
  display: flex
  background-color white

  .link
    color #798696

    &:hover
      color #000E28
  .active
    color #000E28

.v-list
  .link
    color #798696
    border-bottom 1px solid #EFF3F7
    width 100%

  .active
    background-color #EFF3F7

    .link
      color #009BFF
</style>
